import { cn } from '@/lib/cn';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/controle-leiteiro', label: 'Visão geral', end: true },
  { to: '/controle-leiteiro/lancamentos', label: 'Lançamentos' },
  { to: '/controle-leiteiro/lote', label: 'Em lote' },
  { to: '/controle-leiteiro/relatorio', label: 'Relatório' },
] as const;

export function DairySubnav() {
  const { pathname } = useLocation();

  return (
    <nav className="mb-6 flex flex-wrap gap-1 rounded-2xl border border-manejai-sand bg-manejai-cream/40 p-1">
      {TABS.map((tab) => {
        const active =
          'end' in tab && tab.end
            ? pathname === tab.to
            : pathname === tab.to || pathname.startsWith(`${tab.to}/`);
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={cn(
              'rounded-xl px-3 py-2 text-sm font-medium transition-colors',
              active
                ? 'bg-white text-manejai-forest shadow-sm'
                : 'text-manejai-bark/70 hover:text-manejai-forest',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
